import { Link } from "react-router-dom";
import { useSetting } from "./hooks/useSetting";
import { showToast } from "../../core/utils/alert";

const SettingModals: React.FC<{ settingId?: string }> = ({ settingId }) => {

  const { deleteSetting } = useSetting();

  const handleDelete = async () => {
    console.log('clicked', settingId)
    if (settingId) {
      const result: any = await deleteSetting(settingId);
      if (result.success) {
        showToast({
          title: "Success",
          text: result.message || "Record deleted successfully",
          icon: "success",
        });
      } else {
        showToast({
          title: "Error",
          text: result.error || "Could not delete the record",
          icon: "error",
        });
        console.error(result.error);
      }
    }
  };

  return (
    <>
      {/* Delete Modal */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={(e) => { e.preventDefault(); handleDelete(); }}>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-trash" />
                </span>
                <h4>Confirm Deletion</h4>
                <p>
                  You want to delete the record, this can't be undone
                  once you delete.
                </p>
                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-light me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Delete Modal */}
    </>
  );
};

export default SettingModals;

export { };
